import BaseApi from './base'

class PeriodClose extends BaseApi {
  constructor () {
    super()
  }

  async getList(limit = 50, offset = 0) {
    return this.auth({
      url: `/period_close`,
      method: 'GET',
      params: { limit, offset },
    })
  } 

  async get (pd_close_id) {
    return this.auth({
      url: `/period_close/${pd_close_id}`,
      method: 'GET'
    })
  }

  async getByYearPeriod (billing_year_id, billing_period_id) {
    return this.auth({
      url: `/period_close/year_period/${billing_year_id}/${billing_period_id}`,
      method: 'GET'
    })
  }

  async add (data) {
    return this.auth({
      url: `/period_close`,
      method: 'POST',
      data
    })
  }

  async update (pd_close_id, data) {
    return this.auth({
      url: `/period_close/${pd_close_id}`,
      method: 'PUT',
      data
    })
  }
}

export default new PeriodClose()